import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  readonly id: number;
  readonly type: ToastType;
  readonly title: string;
  readonly messages: readonly string[];
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 0;

  readonly toasts = signal<readonly Toast[]>([]);

  success(title: string, ...messages: string[]): void {
    this.add('success', title, messages);
  }

  error(title: string, ...messages: string[]): void {
    this.add('error', title, messages);
  }

  warning(title: string, ...messages: string[]): void {
    this.add('warning', title, messages);
  }

  info(title: string, ...messages: string[]): void {
    this.add('info', title, messages);
  }

  dismiss(id: number): void {
    this.toasts.update((list) => list.filter((t) => t.id !== id));
  }

  private add(type: ToastType, title: string, messages: string[]): void {
    const id = this.nextId++;
    this.toasts.update((list) => [...list, { id, type, title, messages }]);

    const duration = type === 'error' ? 8000 : 5000;
    setTimeout(() => this.dismiss(id), duration);
  }
}
